// Auto Generated file, do not modify
import {
    apiDelete,
    apiGet,
    apiPost,
    apiPut,
    ApiRequestOptions,
} from "@redriver/cinnamon";
import {
    AdminCommentRequest,
    AmendExpiryDateRequest,
    CalculateFunderSheetRequest,
    CalculateSheetRequest,
    CloneSheetRequest,
    CreateSheetRequest,
    DuplicateSheetToNewMasterRequest,
    MakeSheetLiveRequest,
    RenameSheetRequest,
    RenewSheetRequest,
    SheetSaveAsRequest,
    UpdateApplicableFromRequest,
    UpdateSheetDetailsRequest,
    UpdateSheetOwnerRequest,
    VerifyUnlockViewRequest,
} from "mortar/Principal/Endpoints/Sheets";
import { CanMoveSheetRequest } from "mortar/Principal/Endpoints/Sheets/Actions";
import {
    SheetCustomerApprovalSubmitRequest,
    SubmitSupplierPreApprovalRequest,
} from "mortar/Principal/Endpoints/Sheets/Approval";
import {
    PreApprovalDeclinedRequest,
    VoidEnvelopeRequest,
} from "mortar/Principal/Endpoints/Sheets/Models";
import {
    CreateNoteRequest,
    EditNoteRequest,
} from "mortar/Principal/Endpoints/Sheets/Notes";
import {
    SetPhysicalDocumentSheetStateRequest,
    SetSheetCurrentScheduleReferenceRequest,
} from "mortar/Principal/Endpoints/Sheets/Workflow";
import { DocumentRecipientView } from "mortar/Principal/Logic/DocumentRecipients";
import { LookupView } from "mortar/Principal/Logic/Helpers";
import { ImpersonateUsersLookupView } from "mortar/Principal/Logic/Lookups/Views";
import {
    SheetCalculatorResult,
    SheetCalculatorResultDto,
} from "mortar/Principal/Logic/Sheets/Calculator";
import {
    CanDeleteScheduleItemView,
    DuplicateSheetNameView,
    SheetHeaderDetailsView,
} from "mortar/Principal/Logic/Sheets/Views";
import { SheetWorkflowStatusView } from "mortar/Principal/Logic/Sheets/Workflow/Views";
import { ValueTuple } from "mortar/System";
import { Stream } from "mortar/System/IO";
import { makeAction, makeFormData } from "../lib";

export interface SheetStatesIpsLookupActionRequest {
    options?: Partial<
        ApiRequestOptions<LookupView[], "sheets/sheetStatesIpsLookup">
    >;
}

export const sheetStatesIpsLookup = makeAction((
    { options }: SheetStatesIpsLookupActionRequest = {},
) => apiGet<LookupView[], "sheets/sheetStatesIpsLookup">(
    "sheets/sheetStatesIpsLookup",
    `lookups/sheet-states-ips`,
    undefined,
    options,
), "sheets/sheetStatesIpsLookup");

export interface GetSheetsActionRequest {
    options?: Partial<ApiRequestOptions<void, "sheets/getSheets">>;
}

export const getSheets = makeAction((
    { options }: GetSheetsActionRequest = {},
) => apiGet<void, "sheets/getSheets">(
    "sheets/getSheets",
    `sheets`,
    undefined,
    options,
), "sheets/getSheets");

export interface CreateSheetActionRequest {
    request: CreateSheetRequest;
    options?: Partial<ApiRequestOptions<void, "sheets/createSheet">>;
}

export const createSheet = makeAction((
    { request, options }: CreateSheetActionRequest,
) => apiPost<void, "sheets/createSheet">(
    "sheets/createSheet",
    `sheets`,
    request,
    options,
), "sheets/createSheet");

export interface ImpersonateUserClaimsQueryParams {
    userId: string;
}

export interface ImpersonateUserClaimsActionRequest {
    queryParams: ImpersonateUserClaimsQueryParams;
    options?: Partial<
        ApiRequestOptions<
            ImpersonateUsersLookupView,
            "sheets/impersonateUserClaims"
        >
    >;
}

export const impersonateUserClaims = makeAction((
    { queryParams, options }: ImpersonateUserClaimsActionRequest,
) => apiGet<ImpersonateUsersLookupView, "sheets/impersonateUserClaims">(
    "sheets/impersonateUserClaims",
    `sheets/impersonate-user-claims`,
    queryParams,
    options,
), "sheets/impersonateUserClaims");

export interface LoadSheetDetailsRouteParams {
    sheetId: string;
}

export interface LoadSheetDetailsActionRequest {
    routeParams: LoadSheetDetailsRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/loadSheetDetails">>;
}

export const loadSheetDetails = makeAction((
    { routeParams, options }: LoadSheetDetailsActionRequest,
) => apiGet<void, "sheets/loadSheetDetails">(
    "sheets/loadSheetDetails",
    `sheets/${routeParams.sheetId}`,
    undefined,
    options,
), "sheets/loadSheetDetails");

export interface UpdateSheetDetailsRouteParams {
    sheetId: string;
}

export interface UpdateSheetDetailsActionRequest {
    routeParams: UpdateSheetDetailsRouteParams;
    request: UpdateSheetDetailsRequest;
    options?: Partial<ApiRequestOptions<void, "sheets/updateSheetDetails">>;
}

export const updateSheetDetails = makeAction((
    { routeParams, request, options }: UpdateSheetDetailsActionRequest,
) => apiPut<void, "sheets/updateSheetDetails">(
    "sheets/updateSheetDetails",
    `sheets/${routeParams.sheetId}`,
    request,
    options,
), "sheets/updateSheetDetails");

export interface UpdateAdminCommentRouteParams {
    sheetId: string;
}

export interface UpdateAdminCommentActionRequest {
    routeParams: UpdateAdminCommentRouteParams;
    request: AdminCommentRequest;
    options?: Partial<ApiRequestOptions<void, "sheets/updateAdminComment">>;
}

export const updateAdminComment = makeAction((
    { routeParams, request, options }: UpdateAdminCommentActionRequest,
) => apiPut<void, "sheets/updateAdminComment">(
    "sheets/updateAdminComment",
    `sheets/${routeParams.sheetId}/admin-comment`,
    request,
    options,
), "sheets/updateAdminComment");

export interface AmendExpiryDateRouteParams {
    sheetId: string;
}

export interface AmendExpiryDateActionRequest {
    routeParams: AmendExpiryDateRouteParams;
    request: AmendExpiryDateRequest;
    options?: Partial<ApiRequestOptions<void, "sheets/amendExpiryDate">>;
}

export const amendExpiryDate = makeAction((
    { routeParams, request, options }: AmendExpiryDateActionRequest,
) => apiPut<void, "sheets/amendExpiryDate">(
    "sheets/amendExpiryDate",
    `sheets/${routeParams.sheetId}/amend-expiry-date`,
    request,
    options,
), "sheets/amendExpiryDate");

export interface UpdateApplicableFromRouteParams {
    sheetId: string;
}

export interface UpdateApplicableFromActionRequest {
    routeParams: UpdateApplicableFromRouteParams;
    request: UpdateApplicableFromRequest;
    options?: Partial<ApiRequestOptions<void, "sheets/updateApplicableFrom">>;
}

export const updateApplicableFrom = makeAction((
    { routeParams, request, options }: UpdateApplicableFromActionRequest,
) => apiPut<void, "sheets/updateApplicableFrom">(
    "sheets/updateApplicableFrom",
    `sheets/${routeParams.sheetId}/applicable-from`,
    request,
    options,
), "sheets/updateApplicableFrom");

export interface ArchiveSheetRouteParams {
    sheetId: string;
}

export interface ArchiveSheetActionRequest {
    routeParams: ArchiveSheetRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/archiveSheet">>;
}

export const archiveSheet = makeAction((
    { routeParams, options }: ArchiveSheetActionRequest,
) => apiPut<void, "sheets/archiveSheet">(
    "sheets/archiveSheet",
    `sheets/${routeParams.sheetId}/archive`,
    undefined,
    options,
), "sheets/archiveSheet");

export interface GetSheetAuditsRouteParams {
    sheetId: string;
}

export interface GetSheetAuditsQueryParams {
    pageSize: number;
    pageNumber: number;
}

export interface GetSheetAuditsActionRequest {
    routeParams: GetSheetAuditsRouteParams;
    queryParams: GetSheetAuditsQueryParams;
    options?: Partial<ApiRequestOptions<void, "sheets/getSheetAudits">>;
}

export const getSheetAudits = makeAction((
    { routeParams, queryParams, options }: GetSheetAuditsActionRequest,
) => apiGet<void, "sheets/getSheetAudits">(
    "sheets/getSheetAudits",
    `sheets/${routeParams.sheetId}/audit`,
    queryParams,
    options,
), "sheets/getSheetAudits");

export interface CalculateSheetRouteParams {
    sheetId: string;
}

export interface CalculateSheetActionRequest {
    routeParams: CalculateSheetRouteParams;
    request: CalculateSheetRequest;
    options?: Partial<
        ApiRequestOptions<SheetCalculatorResult, "sheets/calculateSheet">
    >;
}

export const calculateSheet = makeAction((
    { routeParams, request, options }: CalculateSheetActionRequest,
) => apiPost<SheetCalculatorResult, "sheets/calculateSheet">(
    "sheets/calculateSheet",
    `sheets/${routeParams.sheetId}/calculate`,
    request,
    options,
), "sheets/calculateSheet");

export interface CalculateFunderPrintRouteParams {
    sheetId: string;
}

export interface CalculateFunderPrintActionRequest {
    routeParams: CalculateFunderPrintRouteParams;
    request: CalculateFunderSheetRequest;
    options?: Partial<
        ApiRequestOptions<
            ValueTuple<SheetCalculatorResultDto, SheetCalculatorResultDto>,
            "sheets/calculateFunderPrint"
        >
    >;
}

export const calculateFunderPrint = makeAction((
    { routeParams, request, options }: CalculateFunderPrintActionRequest,
) => apiPost<
    ValueTuple<SheetCalculatorResultDto, SheetCalculatorResultDto>,
    "sheets/calculateFunderPrint"
>(
    "sheets/calculateFunderPrint",
    `sheets/${routeParams.sheetId}/calculate-funder-print`,
    request,
    options,
), "sheets/calculateFunderPrint");

export interface GetMoveSheetDataRouteParams {
    sheetId: string;
}

export interface GetMoveSheetDataActionRequest {
    routeParams: GetMoveSheetDataRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/getMoveSheetData">>;
}

export const getMoveSheetData = makeAction((
    { routeParams, options }: GetMoveSheetDataActionRequest,
) => apiGet<void, "sheets/getMoveSheetData">(
    "sheets/getMoveSheetData",
    `sheets/${routeParams.sheetId}/can-move`,
    undefined,
    options,
), "sheets/getMoveSheetData");

export interface CanMoveSheetRouteParams {
    sheetId: string;
}

export interface CanMoveSheetActionRequest {
    routeParams: CanMoveSheetRouteParams;
    request: CanMoveSheetRequest;
    options?: Partial<ApiRequestOptions<void, "sheets/canMoveSheet">>;
}

export const canMoveSheet = makeAction((
    { routeParams, request, options }: CanMoveSheetActionRequest,
) => apiPost<void, "sheets/canMoveSheet">(
    "sheets/canMoveSheet",
    `sheets/${routeParams.sheetId}/can-move`,
    request,
    options,
), "sheets/canMoveSheet");

export interface CanDeleteScheduleItemRouteParams {
    sheetId: string;
}

export interface CanDeleteScheduleItemQueryParams {
    isLargeFormat: boolean;
    scheduleItemId: string;
}

export interface CanDeleteScheduleItemActionRequest {
    routeParams: CanDeleteScheduleItemRouteParams;
    queryParams: CanDeleteScheduleItemQueryParams;
    options?: Partial<
        ApiRequestOptions<
            CanDeleteScheduleItemView,
            "sheets/canDeleteScheduleItem"
        >
    >;
}

export const canDeleteScheduleItem = makeAction((
    { routeParams, queryParams, options }: CanDeleteScheduleItemActionRequest,
) => apiGet<CanDeleteScheduleItemView, "sheets/canDeleteScheduleItem">(
    "sheets/canDeleteScheduleItem",
    `sheets/${routeParams.sheetId}/check-schedule-item-delete`,
    queryParams,
    options,
), "sheets/canDeleteScheduleItem");

export interface ClientSignatureOverrideRouteParams {
    sheetId: string;
}

export interface ClientSignatureOverrideActionRequest {
    routeParams: ClientSignatureOverrideRouteParams;
    options?: Partial<
        ApiRequestOptions<void, "sheets/clientSignatureOverride">
    >;
}

export const clientSignatureOverride = makeAction((
    { routeParams, options }: ClientSignatureOverrideActionRequest,
) => apiPost<void, "sheets/clientSignatureOverride">(
    "sheets/clientSignatureOverride",
    `sheets/${routeParams.sheetId}/client-sign-override`,
    undefined,
    options,
), "sheets/clientSignatureOverride");

export interface CloneSheetRouteParams {
    sheetId: string;
}

export interface CloneSheetActionRequest {
    routeParams: CloneSheetRouteParams;
    request: CloneSheetRequest;
    options?: Partial<ApiRequestOptions<void, "sheets/cloneSheet">>;
}

export const cloneSheet = makeAction((
    { routeParams, request, options }: CloneSheetActionRequest,
) => apiPost<void, "sheets/cloneSheet">(
    "sheets/cloneSheet",
    `sheets/${routeParams.sheetId}/clone`,
    request,
    options,
), "sheets/cloneSheet");

export interface CrystalliseSheetRouteParams {
    sheetId: string;
}

export interface CrystalliseSheetActionRequest {
    routeParams: CrystalliseSheetRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/crystalliseSheet">>;
}

export const crystalliseSheet = makeAction((
    { routeParams, options }: CrystalliseSheetActionRequest,
) => apiPut<void, "sheets/crystalliseSheet">(
    "sheets/crystalliseSheet",
    `sheets/${routeParams.sheetId}/crystallise`,
    undefined,
    options,
), "sheets/crystalliseSheet");

export interface SetSheetCurrentScheduleReferenceRouteParams {
    sheetId: string;
}

export interface SetSheetCurrentScheduleReferenceActionRequest {
    routeParams: SetSheetCurrentScheduleReferenceRouteParams;
    request: SetSheetCurrentScheduleReferenceRequest;
    options?: Partial<
        ApiRequestOptions<void, "sheets/setSheetCurrentScheduleReference">
    >;
}

export const setSheetCurrentScheduleReference = makeAction((
    { routeParams, request, options }:
        SetSheetCurrentScheduleReferenceActionRequest,
) => apiPut<void, "sheets/setSheetCurrentScheduleReference">(
    "sheets/setSheetCurrentScheduleReference",
    `sheets/${routeParams.sheetId}/current-schedule`,
    request,
    options,
), "sheets/setSheetCurrentScheduleReference");

export interface DeleteSheetRouteParams {
    sheetId: string;
}

export interface DeleteSheetActionRequest {
    routeParams: DeleteSheetRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/deleteSheet">>;
}

export const deleteSheet = makeAction((
    { routeParams, options }: DeleteSheetActionRequest,
) => apiDelete<void, "sheets/deleteSheet">(
    "sheets/deleteSheet",
    `sheets/${routeParams.sheetId}/delete`,
    undefined,
    options,
), "sheets/deleteSheet");

export interface GetDocusignRecipientsRouteParams {
    sheetId: string;
}

export interface GetDocusignRecipientsActionRequest {
    routeParams: GetDocusignRecipientsRouteParams;
    options?: Partial<
        ApiRequestOptions<
            DocumentRecipientView[],
            "sheets/getDocusignRecipients"
        >
    >;
}

export const getDocusignRecipients = makeAction((
    { routeParams, options }: GetDocusignRecipientsActionRequest,
) => apiGet<DocumentRecipientView[], "sheets/getDocusignRecipients">(
    "sheets/getDocusignRecipients",
    `sheets/${routeParams.sheetId}/document-recipients`,
    undefined,
    options,
), "sheets/getDocusignRecipients");

export interface DownloadAdminSheetRouteParams {
    sheetId: string;
}

export interface DownloadAdminSheetActionRequest {
    routeParams: DownloadAdminSheetRouteParams;
    options?: Partial<ApiRequestOptions<Stream, "sheets/downloadAdminSheet">>;
}

export const downloadAdminSheet = makeAction((
    { routeParams, options }: DownloadAdminSheetActionRequest,
) => apiGet<Stream, "sheets/downloadAdminSheet">(
    "sheets/downloadAdminSheet",
    `sheets/${routeParams.sheetId}/download-admin-print`,
    undefined,
    options,
), "sheets/downloadAdminSheet");

export interface DownloadFunderPrintRouteParams {
    sheetId: string;
}

export interface DownloadFunderPrintQueryParams {
    ipsNetRateOverride: number;
}

export interface DownloadFunderPrintActionRequest {
    routeParams: DownloadFunderPrintRouteParams;
    queryParams: DownloadFunderPrintQueryParams;
    options?: Partial<ApiRequestOptions<Stream, "sheets/downloadFunderPrint">>;
}

export const downloadFunderPrint = makeAction((
    { routeParams, queryParams, options }: DownloadFunderPrintActionRequest,
) => apiGet<Stream, "sheets/downloadFunderPrint">(
    "sheets/downloadFunderPrint",
    `sheets/${routeParams.sheetId}/download-funder-print`,
    queryParams,
    options,
), "sheets/downloadFunderPrint");

export interface DownloadRewriteSheetRouteParams {
    sheetId: string;
}

export interface DownloadRewriteSheetActionRequest {
    routeParams: DownloadRewriteSheetRouteParams;
    options?: Partial<ApiRequestOptions<Stream, "sheets/downloadRewriteSheet">>;
}

export const downloadRewriteSheet = makeAction((
    { routeParams, options }: DownloadRewriteSheetActionRequest,
) => apiGet<Stream, "sheets/downloadRewriteSheet">(
    "sheets/downloadRewriteSheet",
    `sheets/${routeParams.sheetId}/download-rewrite-print`,
    undefined,
    options,
), "sheets/downloadRewriteSheet");

export interface DownloadCapitalCalcAdminInfoRouteParams {
    sheetId: string;
}

export interface DownloadCapitalCalcAdminInfoActionRequest {
    routeParams: DownloadCapitalCalcAdminInfoRouteParams;
    options?: Partial<
        ApiRequestOptions<void, "sheets/downloadCapitalCalcAdminInfo">
    >;
}

export const downloadCapitalCalcAdminInfo = makeAction((
    { routeParams, options }: DownloadCapitalCalcAdminInfoActionRequest,
) => apiGet<void, "sheets/downloadCapitalCalcAdminInfo">(
    "sheets/downloadCapitalCalcAdminInfo",
    `sheets/${routeParams.sheetId}/download/capital-calc-admin-info`,
    undefined,
    options,
), "sheets/downloadCapitalCalcAdminInfo");

export interface DownloadComparisonSnapshotRouteParams {
    sheetId: string;
}

export interface DownloadComparisonSnapshotActionRequest {
    routeParams: DownloadComparisonSnapshotRouteParams;
    options?: Partial<
        ApiRequestOptions<void, "sheets/downloadComparisonSnapshot">
    >;
}

export const downloadComparisonSnapshot = makeAction((
    { routeParams, options }: DownloadComparisonSnapshotActionRequest,
) => apiGet<void, "sheets/downloadComparisonSnapshot">(
    "sheets/downloadComparisonSnapshot",
    `sheets/${routeParams.sheetId}/download/comparison-snapshot`,
    undefined,
    options,
), "sheets/downloadComparisonSnapshot");

export interface DownloadDirectDebitAddendumRouteParams {
    sheetId: string;
}

export interface DownloadDirectDebitAddendumActionRequest {
    routeParams: DownloadDirectDebitAddendumRouteParams;
    options?: Partial<
        ApiRequestOptions<void, "sheets/downloadDirectDebitAddendum">
    >;
}

export const downloadDirectDebitAddendum = makeAction((
    { routeParams, options }: DownloadDirectDebitAddendumActionRequest,
) => apiGet<void, "sheets/downloadDirectDebitAddendum">(
    "sheets/downloadDirectDebitAddendum",
    `sheets/${routeParams.sheetId}/download/direct-debit-addendum`,
    undefined,
    options,
), "sheets/downloadDirectDebitAddendum");

export interface DownloadDocumentPackRouteParams {
    sheetId: string;
}

export interface DownloadDocumentPackActionRequest {
    routeParams: DownloadDocumentPackRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/downloadDocumentPack">>;
}

export const downloadDocumentPack = makeAction((
    { routeParams, options }: DownloadDocumentPackActionRequest,
) => apiGet<void, "sheets/downloadDocumentPack">(
    "sheets/downloadDocumentPack",
    `sheets/${routeParams.sheetId}/download/document-pack`,
    undefined,
    options,
), "sheets/downloadDocumentPack");

export interface DownloadLfpRouteParams {
    sheetId: string;
}

export interface DownloadLfpQueryParams {
    sheetId: string;
    loadAdmin: boolean;
}

export interface DownloadLfpActionRequest {
    routeParams: DownloadLfpRouteParams;
    queryParams: DownloadLfpQueryParams;
    options?: Partial<ApiRequestOptions<void, "sheets/downloadLfp">>;
}

export const downloadLfp = makeAction((
    { routeParams, queryParams, options }: DownloadLfpActionRequest,
) => apiGet<void, "sheets/downloadLfp">(
    "sheets/downloadLfp",
    `sheets/${routeParams.sheetId}/download/lfp`,
    queryParams,
    options,
), "sheets/downloadLfp");

export interface DownloadPaperInclusiveRouteParams {
    sheetId: string;
}

export interface DownloadPaperInclusiveActionRequest {
    routeParams: DownloadPaperInclusiveRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/downloadPaperInclusive">>;
}

export const downloadPaperInclusive = makeAction((
    { routeParams, options }: DownloadPaperInclusiveActionRequest,
) => apiGet<void, "sheets/downloadPaperInclusive">(
    "sheets/downloadPaperInclusive",
    `sheets/${routeParams.sheetId}/download/paper-inclusive`,
    undefined,
    options,
), "sheets/downloadPaperInclusive");

export interface DownloadPaperInclusiveAddendumRouteParams {
    sheetId: string;
}

export interface DownloadPaperInclusiveAddendumActionRequest {
    routeParams: DownloadPaperInclusiveAddendumRouteParams;
    options?: Partial<
        ApiRequestOptions<void, "sheets/downloadPaperInclusiveAddendum">
    >;
}

export const downloadPaperInclusiveAddendum = makeAction((
    { routeParams, options }: DownloadPaperInclusiveAddendumActionRequest,
) => apiGet<void, "sheets/downloadPaperInclusiveAddendum">(
    "sheets/downloadPaperInclusiveAddendum",
    `sheets/${routeParams.sheetId}/download/paper-inclusive-addendum`,
    undefined,
    options,
), "sheets/downloadPaperInclusiveAddendum");

export interface DownloadPrincipalLfpAddendumRouteParams {
    sheetId: string;
}

export interface DownloadPrincipalLfpAddendumActionRequest {
    routeParams: DownloadPrincipalLfpAddendumRouteParams;
    options?: Partial<
        ApiRequestOptions<void, "sheets/downloadPrincipalLfpAddendum">
    >;
}

export const downloadPrincipalLfpAddendum = makeAction((
    { routeParams, options }: DownloadPrincipalLfpAddendumActionRequest,
) => apiGet<void, "sheets/downloadPrincipalLfpAddendum">(
    "sheets/downloadPrincipalLfpAddendum",
    `sheets/${routeParams.sheetId}/download/principal-lfp-addendum`,
    undefined,
    options,
), "sheets/downloadPrincipalLfpAddendum");

export interface DownloadPrincipalSoftwareSupportAddendumRouteParams {
    sheetId: string;
}

export interface DownloadPrincipalSoftwareSupportAddendumActionRequest {
    routeParams: DownloadPrincipalSoftwareSupportAddendumRouteParams;
    options?: Partial<
        ApiRequestOptions<
            void,
            "sheets/downloadPrincipalSoftwareSupportAddendum"
        >
    >;
}

export const downloadPrincipalSoftwareSupportAddendum = makeAction((
    { routeParams, options }:
        DownloadPrincipalSoftwareSupportAddendumActionRequest,
) => apiGet<void, "sheets/downloadPrincipalSoftwareSupportAddendum">(
    "sheets/downloadPrincipalSoftwareSupportAddendum",
    `sheets/${routeParams.sheetId}/download/principal-software-support-addendum`,
    undefined,
    options,
), "sheets/downloadPrincipalSoftwareSupportAddendum");

export interface DownloadProductScheduleAddendumRouteParams {
    sheetId: string;
}

export interface DownloadProductScheduleAddendumActionRequest {
    routeParams: DownloadProductScheduleAddendumRouteParams;
    options?: Partial<
        ApiRequestOptions<void, "sheets/downloadProductScheduleAddendum">
    >;
}

export const downloadProductScheduleAddendum = makeAction((
    { routeParams, options }: DownloadProductScheduleAddendumActionRequest,
) => apiGet<void, "sheets/downloadProductScheduleAddendum">(
    "sheets/downloadProductScheduleAddendum",
    `sheets/${routeParams.sheetId}/download/product-schedule-addendum`,
    undefined,
    options,
), "sheets/downloadProductScheduleAddendum");

export interface DownloadSheetContractRouteParams {
    sheetId: string;
}

export interface DownloadSheetContractQueryParams {
    isPreview: boolean;
}

export interface DownloadSheetContractActionRequest {
    routeParams: DownloadSheetContractRouteParams;
    queryParams: DownloadSheetContractQueryParams;
    options?: Partial<ApiRequestOptions<void, "sheets/downloadSheetContract">>;
}

export const downloadSheetContract = makeAction((
    { routeParams, queryParams, options }: DownloadSheetContractActionRequest,
) => apiGet<void, "sheets/downloadSheetContract">(
    "sheets/downloadSheetContract",
    `sheets/${routeParams.sheetId}/download/sheet-contract`,
    queryParams,
    options,
), "sheets/downloadSheetContract");

export interface GetSheetDuplicateNameRouteParams {
    sheetId: string;
}

export interface GetSheetDuplicateNameQueryParams {
    duplicateToNewMaster: boolean;
}

export interface GetSheetDuplicateNameActionRequest {
    routeParams: GetSheetDuplicateNameRouteParams;
    queryParams: GetSheetDuplicateNameQueryParams;
    options?: Partial<
        ApiRequestOptions<
            DuplicateSheetNameView,
            "sheets/getSheetDuplicateName"
        >
    >;
}

export const getSheetDuplicateName = makeAction((
    { routeParams, queryParams, options }: GetSheetDuplicateNameActionRequest,
) => apiGet<DuplicateSheetNameView, "sheets/getSheetDuplicateName">(
    "sheets/getSheetDuplicateName",
    `sheets/${routeParams.sheetId}/duplicate-name`,
    queryParams,
    options,
), "sheets/getSheetDuplicateName");

export interface DuplicateSheetToNewMasterRouteParams {
    sheetId: string;
}

export interface DuplicateSheetToNewMasterActionRequest {
    routeParams: DuplicateSheetToNewMasterRouteParams;
    request: DuplicateSheetToNewMasterRequest;
    options?: Partial<
        ApiRequestOptions<void, "sheets/duplicateSheetToNewMaster">
    >;
}

export const duplicateSheetToNewMaster = makeAction((
    { routeParams, request, options }: DuplicateSheetToNewMasterActionRequest,
) => apiPost<void, "sheets/duplicateSheetToNewMaster">(
    "sheets/duplicateSheetToNewMaster",
    `sheets/${routeParams.sheetId}/duplicate-to-new-master`,
    request,
    options,
), "sheets/duplicateSheetToNewMaster");

export interface GetSheetHeaderDetailsRouteParams {
    sheetId: string;
}

export interface GetSheetHeaderDetailsActionRequest {
    routeParams: GetSheetHeaderDetailsRouteParams;
    options?: Partial<
        ApiRequestOptions<
            SheetHeaderDetailsView,
            "sheets/getSheetHeaderDetails"
        >
    >;
}

export const getSheetHeaderDetails = makeAction((
    { routeParams, options }: GetSheetHeaderDetailsActionRequest,
) => apiGet<SheetHeaderDetailsView, "sheets/getSheetHeaderDetails">(
    "sheets/getSheetHeaderDetails",
    `sheets/${routeParams.sheetId}/header-details`,
    undefined,
    options,
), "sheets/getSheetHeaderDetails");

export interface SetIpsPhysicalApprovalRouteParams {
    sheetId: string;
}

export interface SetIpsPhysicalApprovalActionRequest {
    routeParams: SetIpsPhysicalApprovalRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/setIpsPhysicalApproval">>;
}

export const setIpsPhysicalApproval = makeAction((
    { routeParams, options }: SetIpsPhysicalApprovalActionRequest,
) => apiPost<void, "sheets/setIpsPhysicalApproval">(
    "sheets/setIpsPhysicalApproval",
    `sheets/${routeParams.sheetId}/ips-physical-approval`,
    undefined,
    options,
), "sheets/setIpsPhysicalApproval");

export interface IpsOrFunderSignatureOverrideRouteParams {
    sheetId: string;
}

export interface IpsOrFunderSignatureOverrideActionRequest {
    routeParams: IpsOrFunderSignatureOverrideRouteParams;
    options?: Partial<
        ApiRequestOptions<void, "sheets/ipsOrFunderSignatureOverride">
    >;
}

export const ipsOrFunderSignatureOverride = makeAction((
    { routeParams, options }: IpsOrFunderSignatureOverrideActionRequest,
) => apiPut<void, "sheets/ipsOrFunderSignatureOverride">(
    "sheets/ipsOrFunderSignatureOverride",
    `sheets/${routeParams.sheetId}/ips-sign-override`,
    undefined,
    options,
), "sheets/ipsOrFunderSignatureOverride");

export interface MakeSheetLiveRouteParams {
    sheetId: string;
}

export interface MakeSheetLiveActionRequest {
    routeParams: MakeSheetLiveRouteParams;
    request: MakeSheetLiveRequest;
    options?: Partial<ApiRequestOptions<void, "sheets/makeSheetLive">>;
}

export const makeSheetLive = makeAction((
    { routeParams, request, options }: MakeSheetLiveActionRequest,
) => apiPut<void, "sheets/makeSheetLive">(
    "sheets/makeSheetLive",
    `sheets/${routeParams.sheetId}/make-live`,
    request,
    options,
), "sheets/makeSheetLive");

export interface GetNotesRouteParams {
    sheetId: string;
}

export interface GetNotesQueryParams {
    pageSize: number;
    pageNumber: number;
}

export interface GetNotesActionRequest {
    routeParams: GetNotesRouteParams;
    queryParams: GetNotesQueryParams;
    options?: Partial<ApiRequestOptions<void, "sheets/getNotes">>;
}

export const getNotes = makeAction((
    { routeParams, queryParams, options }: GetNotesActionRequest,
) => apiGet<void, "sheets/getNotes">(
    "sheets/getNotes",
    `sheets/${routeParams.sheetId}/notes`,
    queryParams,
    options,
), "sheets/getNotes");

export interface CreateNoteRouteParams {
    sheetId: string;
}

export interface CreateNoteActionRequest {
    routeParams: CreateNoteRouteParams;
    request: CreateNoteRequest;
    options?: Partial<ApiRequestOptions<void, "sheets/createNote">>;
}

export const createNote = makeAction((
    { routeParams, request, options }: CreateNoteActionRequest,
) => apiPost<void, "sheets/createNote">(
    "sheets/createNote",
    `sheets/${routeParams.sheetId}/notes`,
    request,
    options,
), "sheets/createNote");

export interface EditNoteRouteParams {
    noteId: string;
    sheetId: string;
}

export interface EditNoteActionRequest {
    routeParams: EditNoteRouteParams;
    request: EditNoteRequest;
    options?: Partial<ApiRequestOptions<void, "sheets/editNote">>;
}

export const editNote = makeAction((
    { routeParams, request, options }: EditNoteActionRequest,
) => apiPut<void, "sheets/editNote">(
    "sheets/editNote",
    `sheets/${routeParams.sheetId}/notes/${routeParams.noteId}`,
    request,
    options,
), "sheets/editNote");

export interface DeleteNoteRouteParams {
    sheetId: string;
    noteId: string;
}

export interface DeleteNoteActionRequest {
    routeParams: DeleteNoteRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/deleteNote">>;
}

export const deleteNote = makeAction((
    { routeParams, options }: DeleteNoteActionRequest,
) => apiDelete<void, "sheets/deleteNote">(
    "sheets/deleteNote",
    `sheets/${routeParams.sheetId}/notes/${routeParams.noteId}`,
    undefined,
    options,
), "sheets/deleteNote");

export interface ToggleSheetReadOnlyRouteParams {
    sheetId: string;
}

export interface ToggleSheetReadOnlyActionRequest {
    routeParams: ToggleSheetReadOnlyRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/toggleSheetReadOnly">>;
}

export const toggleSheetReadOnly = makeAction((
    { routeParams, options }: ToggleSheetReadOnlyActionRequest,
) => apiPut<void, "sheets/toggleSheetReadOnly">(
    "sheets/toggleSheetReadOnly",
    `sheets/${routeParams.sheetId}/read-only`,
    undefined,
    options,
), "sheets/toggleSheetReadOnly");

export interface RejectDealRouteParams {
    sheetId: string;
}

export interface RejectDealActionRequest {
    routeParams: RejectDealRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/rejectDeal">>;
}

export const rejectDeal = makeAction((
    { routeParams, options }: RejectDealActionRequest,
) => apiPost<void, "sheets/rejectDeal">(
    "sheets/rejectDeal",
    `sheets/${routeParams.sheetId}/reject-deal`,
    undefined,
    options,
), "sheets/rejectDeal");

export interface RenameSheetRouteParams {
    sheetId: string;
}

export interface RenameSheetActionRequest {
    routeParams: RenameSheetRouteParams;
    request: RenameSheetRequest;
    options?: Partial<ApiRequestOptions<void, "sheets/renameSheet">>;
}

export const renameSheet = makeAction((
    { routeParams, request, options }: RenameSheetActionRequest,
) => apiPut<void, "sheets/renameSheet">(
    "sheets/renameSheet",
    `sheets/${routeParams.sheetId}/rename`,
    request,
    options,
), "sheets/renameSheet");

export interface RenewSheetRouteParams {
    sheetId: string;
}

export interface RenewSheetActionRequest {
    routeParams: RenewSheetRouteParams;
    request: RenewSheetRequest;
    options?: Partial<ApiRequestOptions<void, "sheets/renewSheet">>;
}

export const renewSheet = makeAction((
    { routeParams, request, options }: RenewSheetActionRequest,
) => apiPost<void, "sheets/renewSheet">(
    "sheets/renewSheet",
    `sheets/${routeParams.sheetId}/renew`,
    request,
    options,
), "sheets/renewSheet");

export interface ResetSheetStateRouteParams {
    sheetId: string;
}

export interface ResetSheetStateActionRequest {
    routeParams: ResetSheetStateRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/resetSheetState">>;
}

export const resetSheetState = makeAction((
    { routeParams, options }: ResetSheetStateActionRequest,
) => apiPut<void, "sheets/resetSheetState">(
    "sheets/resetSheetState",
    `sheets/${routeParams.sheetId}/reset-sheet-state`,
    undefined,
    options,
), "sheets/resetSheetState");

export interface ResurrectSheetRouteParams {
    sheetId: string;
}

export interface ResurrectSheetActionRequest {
    routeParams: ResurrectSheetRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/resurrectSheet">>;
}

export const resurrectSheet = makeAction((
    { routeParams, options }: ResurrectSheetActionRequest,
) => apiPut<void, "sheets/resurrectSheet">(
    "sheets/resurrectSheet",
    `sheets/${routeParams.sheetId}/resurrect`,
    undefined,
    options,
), "sheets/resurrectSheet");

export interface ToggleSheetRewriteOnlyRouteParams {
    sheetId: string;
}

export interface ToggleSheetRewriteOnlyActionRequest {
    routeParams: ToggleSheetRewriteOnlyRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/toggleSheetRewriteOnly">>;
}

export const toggleSheetRewriteOnly = makeAction((
    { routeParams, options }: ToggleSheetRewriteOnlyActionRequest,
) => apiPut<void, "sheets/toggleSheetRewriteOnly">(
    "sheets/toggleSheetRewriteOnly",
    `sheets/${routeParams.sheetId}/rewrite-only`,
    undefined,
    options,
), "sheets/toggleSheetRewriteOnly");

export interface SheetSaveAsRouteParams {
    sheetId: string;
}

export interface SheetSaveAsActionRequest {
    routeParams: SheetSaveAsRouteParams;
    request: SheetSaveAsRequest;
    options?: Partial<ApiRequestOptions<void, "sheets/sheetSaveAs">>;
}

export const sheetSaveAs = makeAction((
    { routeParams, request, options }: SheetSaveAsActionRequest,
) => apiPost<void, "sheets/sheetSaveAs">(
    "sheets/sheetSaveAs",
    `sheets/${routeParams.sheetId}/save-as`,
    request,
    options,
), "sheets/sheetSaveAs");

export interface SendToFunderRouteParams {
    sheetId: string;
}

export interface SendToFunderActionRequest {
    routeParams: SendToFunderRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/sendToFunder">>;
}

export const sendToFunder = makeAction((
    { routeParams, options }: SendToFunderActionRequest,
) => apiPost<void, "sheets/sendToFunder">(
    "sheets/sendToFunder",
    `sheets/${routeParams.sheetId}/send-to-funder`,
    undefined,
    options,
), "sheets/sendToFunder");

export interface SendToIpsSignatoryRouteParams {
    sheetId: string;
}

export interface SendToIpsSignatoryActionRequest {
    routeParams: SendToIpsSignatoryRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/sendToIpsSignatory">>;
}

export const sendToIpsSignatory = makeAction((
    { routeParams, options }: SendToIpsSignatoryActionRequest,
) => apiPost<void, "sheets/sendToIpsSignatory">(
    "sheets/sendToIpsSignatory",
    `sheets/${routeParams.sheetId}/send-to-ips-signatory`,
    undefined,
    options,
), "sheets/sendToIpsSignatory");

export interface SendToSupplierRouteParams {
    sheetId: string;
}

export interface SendToSupplierActionRequest {
    routeParams: SendToSupplierRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/sendToSupplier">>;
}

export const sendToSupplier = makeAction((
    { routeParams, options }: SendToSupplierActionRequest,
) => apiPost<void, "sheets/sendToSupplier">(
    "sheets/sendToSupplier",
    `sheets/${routeParams.sheetId}/send-to-supplier`,
    undefined,
    options,
), "sheets/sendToSupplier");

export interface UpdateSheetOwnerRouteParams {
    sheetId: string;
}

export interface UpdateSheetOwnerActionRequest {
    routeParams: UpdateSheetOwnerRouteParams;
    request: UpdateSheetOwnerRequest;
    options?: Partial<ApiRequestOptions<void, "sheets/updateSheetOwner">>;
}

export const updateSheetOwner = makeAction((
    { routeParams, request, options }: UpdateSheetOwnerActionRequest,
) => apiPut<void, "sheets/updateSheetOwner">(
    "sheets/updateSheetOwner",
    `sheets/${routeParams.sheetId}/set-owner`,
    request,
    options,
), "sheets/updateSheetOwner");

export interface SubmitSheetRouteParams {
    sheetId: string;
}

export interface SubmitSheetActionRequest {
    routeParams: SubmitSheetRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/submitSheet">>;
}

export const submitSheet = makeAction((
    { routeParams, options }: SubmitSheetActionRequest,
) => apiPost<void, "sheets/submitSheet">(
    "sheets/submitSheet",
    `sheets/${routeParams.sheetId}/submit`,
    undefined,
    options,
), "sheets/submitSheet");

export interface SubmitSheetForCustomerApprovalRouteParams {
    sheetId: string;
}

export interface SubmitSheetForCustomerApprovalActionRequest {
    routeParams: SubmitSheetForCustomerApprovalRouteParams;
    request: SheetCustomerApprovalSubmitRequest;
    options?: Partial<
        ApiRequestOptions<void, "sheets/submitSheetForCustomerApproval">
    >;
}

export const submitSheetForCustomerApproval = makeAction((
    { routeParams, request, options }:
        SubmitSheetForCustomerApprovalActionRequest,
) => apiPost<void, "sheets/submitSheetForCustomerApproval">(
    "sheets/submitSheetForCustomerApproval",
    `sheets/${routeParams.sheetId}/submit/customer-approval`,
    request,
    options,
), "sheets/submitSheetForCustomerApproval");

export interface SubmitIPSPreApprovalRouteParams {
    sheetId: string;
}

export interface SubmitIPSPreApprovalActionRequest {
    routeParams: SubmitIPSPreApprovalRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/submitIPSPreApproval">>;
}

export const submitIPSPreApproval = makeAction((
    { routeParams, options }: SubmitIPSPreApprovalActionRequest,
) => apiPut<void, "sheets/submitIPSPreApproval">(
    "sheets/submitIPSPreApproval",
    `sheets/${routeParams.sheetId}/submit/ips-pre-approval`,
    undefined,
    options,
), "sheets/submitIPSPreApproval");

export interface SubmitIPSPreApprovalDeclinedRouteParams {
    sheetId: string;
}

export interface SubmitIPSPreApprovalDeclinedActionRequest {
    routeParams: SubmitIPSPreApprovalDeclinedRouteParams;
    request: PreApprovalDeclinedRequest;
    options?: Partial<
        ApiRequestOptions<void, "sheets/submitIPSPreApprovalDeclined">
    >;
}

export const submitIPSPreApprovalDeclined = makeAction((
    { routeParams, request, options }:
        SubmitIPSPreApprovalDeclinedActionRequest,
) => apiPut<void, "sheets/submitIPSPreApprovalDeclined">(
    "sheets/submitIPSPreApprovalDeclined",
    `sheets/${routeParams.sheetId}/submit/ips-pre-approval-declined`,
    request,
    options,
), "sheets/submitIPSPreApprovalDeclined");

export interface SubmitPrincipalPreApprovalDeclinedRouteParams {
    sheetId: string;
}

export interface SubmitPrincipalPreApprovalDeclinedActionRequest {
    routeParams: SubmitPrincipalPreApprovalDeclinedRouteParams;
    request: PreApprovalDeclinedRequest;
    options?: Partial<
        ApiRequestOptions<void, "sheets/submitPrincipalPreApprovalDeclined">
    >;
}

export const submitPrincipalPreApprovalDeclined = makeAction((
    { routeParams, request, options }:
        SubmitPrincipalPreApprovalDeclinedActionRequest,
) => apiPut<void, "sheets/submitPrincipalPreApprovalDeclined">(
    "sheets/submitPrincipalPreApprovalDeclined",
    `sheets/${routeParams.sheetId}/submit/principal-pre-approval-declined`,
    request,
    options,
), "sheets/submitPrincipalPreApprovalDeclined");

export interface SubmitSupplierPreApprovalRouteParams {
    sheetId: string;
}

export interface SubmitSupplierPreApprovalActionRequest {
    routeParams: SubmitSupplierPreApprovalRouteParams;
    request: SubmitSupplierPreApprovalRequest;
    options?: Partial<
        ApiRequestOptions<void, "sheets/submitSupplierPreApproval">
    >;
}

export const submitSupplierPreApproval = makeAction((
    { routeParams, request, options }: SubmitSupplierPreApprovalActionRequest,
) => apiPut<void, "sheets/submitSupplierPreApproval">(
    "sheets/submitSupplierPreApproval",
    `sheets/${routeParams.sheetId}/submit/supplier-pre-approval`,
    request,
    options,
), "sheets/submitSupplierPreApproval");

export interface SubmitSupplierPreApprovalDeclinedRouteParams {
    sheetId: string;
}

export interface SubmitSupplierPreApprovalDeclinedActionRequest {
    routeParams: SubmitSupplierPreApprovalDeclinedRouteParams;
    request: PreApprovalDeclinedRequest;
    options?: Partial<
        ApiRequestOptions<void, "sheets/submitSupplierPreApprovalDeclined">
    >;
}

export const submitSupplierPreApprovalDeclined = makeAction((
    { routeParams, request, options }:
        SubmitSupplierPreApprovalDeclinedActionRequest,
) => apiPut<void, "sheets/submitSupplierPreApprovalDeclined">(
    "sheets/submitSupplierPreApprovalDeclined",
    `sheets/${routeParams.sheetId}/submit/supplier-pre-approval-declined`,
    request,
    options,
), "sheets/submitSupplierPreApprovalDeclined");

export interface VoidEnvelopeRouteParams {
    sheetId: string;
}

export interface VoidEnvelopeActionRequest {
    routeParams: VoidEnvelopeRouteParams;
    request: VoidEnvelopeRequest;
    options?: Partial<ApiRequestOptions<void, "sheets/voidEnvelope">>;
}

export const voidEnvelope = makeAction((
    { routeParams, request, options }: VoidEnvelopeActionRequest,
) => apiPut<void, "sheets/voidEnvelope">(
    "sheets/voidEnvelope",
    `sheets/${routeParams.sheetId}/submit/void-envelope`,
    request,
    options,
), "sheets/voidEnvelope");

export interface SyncSheetStatesWithSettingsRouteParams {
    sheetId: string;
}

export interface SyncSheetStatesWithSettingsActionRequest {
    routeParams: SyncSheetStatesWithSettingsRouteParams;
    options?: Partial<
        ApiRequestOptions<void, "sheets/syncSheetStatesWithSettings">
    >;
}

export const syncSheetStatesWithSettings = makeAction((
    { routeParams, options }: SyncSheetStatesWithSettingsActionRequest,
) => apiPost<void, "sheets/syncSheetStatesWithSettings">(
    "sheets/syncSheetStatesWithSettings",
    `sheets/${routeParams.sheetId}/sync`,
    undefined,
    options,
), "sheets/syncSheetStatesWithSettings");

export interface UnarchiveSheetRouteParams {
    sheetId: string;
}

export interface UnarchiveSheetActionRequest {
    routeParams: UnarchiveSheetRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/unarchiveSheet">>;
}

export const unarchiveSheet = makeAction((
    { routeParams, options }: UnarchiveSheetActionRequest,
) => apiPut<void, "sheets/unarchiveSheet">(
    "sheets/unarchiveSheet",
    `sheets/${routeParams.sheetId}/unarchive`,
    undefined,
    options,
), "sheets/unarchiveSheet");

export interface UncrystalliseSheetRouteParams {
    sheetId: string;
}

export interface UncrystalliseSheetActionRequest {
    routeParams: UncrystalliseSheetRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/uncrystalliseSheet">>;
}

export const uncrystalliseSheet = makeAction((
    { routeParams, options }: UncrystalliseSheetActionRequest,
) => apiPut<void, "sheets/uncrystalliseSheet">(
    "sheets/uncrystalliseSheet",
    `sheets/${routeParams.sheetId}/uncrystallise`,
    undefined,
    options,
), "sheets/uncrystalliseSheet");

export interface VoidSheetRouteParams {
    sheetId: string;
}

export interface VoidSheetActionRequest {
    routeParams: VoidSheetRouteParams;
    options?: Partial<ApiRequestOptions<void, "sheets/voidSheet">>;
}

export const voidSheet = makeAction((
    { routeParams, options }: VoidSheetActionRequest,
) => apiPut<void, "sheets/voidSheet">(
    "sheets/voidSheet",
    `sheets/${routeParams.sheetId}/void`,
    undefined,
    options,
), "sheets/voidSheet");

export interface SheetWorkflowRouteParams {
    sheetId: string;
}

export interface SheetWorkflowQueryParams {
    includeDotGraph: boolean;
}

export interface SheetWorkflowActionRequest {
    routeParams: SheetWorkflowRouteParams;
    queryParams: SheetWorkflowQueryParams;
    options?: Partial<
        ApiRequestOptions<SheetWorkflowStatusView, "sheets/sheetWorkflow">
    >;
}

export const sheetWorkflow = makeAction((
    { routeParams, queryParams, options }: SheetWorkflowActionRequest,
) => apiGet<SheetWorkflowStatusView, "sheets/sheetWorkflow">(
    "sheets/sheetWorkflow",
    `sheets/${routeParams.sheetId}/workflow`,
    queryParams,
    options,
), "sheets/sheetWorkflow");

export interface SetPhysicalDocumentSheetStateRouteParams {
    sheetId: string;
}

export interface SetPhysicalDocumentSheetStateActionRequest {
    routeParams: SetPhysicalDocumentSheetStateRouteParams;
    request: SetPhysicalDocumentSheetStateRequest;
    options?: Partial<
        ApiRequestOptions<void, "sheets/setPhysicalDocumentSheetState">
    >;
}

export const setPhysicalDocumentSheetState = makeAction((
    { routeParams, request, options }:
        SetPhysicalDocumentSheetStateActionRequest,
) => apiPut<void, "sheets/setPhysicalDocumentSheetState">(
    "sheets/setPhysicalDocumentSheetState",
    `sheets/${routeParams.sheetId}/workflow/physical-document-state`,
    request,
    options,
), "sheets/setPhysicalDocumentSheetState");

export interface VerifyUnlockViewRouteParams {
    sheetId: string;
}

export interface VerifyUnlockViewActionRequest {
    routeParams: VerifyUnlockViewRouteParams;
    request: VerifyUnlockViewRequest;
    options?: Partial<ApiRequestOptions<void, "sheets/verifyUnlockView">>;
}

export const verifyUnlockView = makeAction((
    { routeParams, request, options }: VerifyUnlockViewActionRequest,
) => apiPost<void, "sheets/verifyUnlockView">(
    "sheets/verifyUnlockView",
    `${routeParams.sheetId}/verify-unlock-view`,
    request,
    options,
), "sheets/verifyUnlockView");
